import React, { Fragment, useState } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import Tooltip from "rc-tooltip";

const Portal = ({ children }) => createPortal(children, document.body);

const Backdrop = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  bottom: 0;
`;

const Dropdown = ({
  align = "right",
  placement = "bottom",
  trigger = ["hover"],
  overlay,
  children,
  visible,
  onVisibleChange
}) => {
  const pos = placement + align.charAt(0).toUpperCase() + align.slice(1);
  const usingClick = ["click", "contextmenu"].some(i => trigger.includes(i));

  return (
    <Fragment>
      {usingClick && <Portal>{visible && <Backdrop />}</Portal>}
      <Tooltip
        trigger={trigger}
        placement={pos}
        overlay={overlay}
        destroyTooltipOnHide
        onVisibleChange={onVisibleChange}
        visible={visible}
      >
        <div>{children}</div>
      </Tooltip>
    </Fragment>
  );
};

export default Dropdown;
